import { render } from "./offer-item-older.vue?vue&type=template&id=def35dfe"
import script from "./offer-item-older.vue?vue&type=script&lang=js"
export * from "./offer-item-older.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__